import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "~/v2/components/ui/card"
import type { VaasCourse } from "~/v2/types/vaas"

const VaasLocationsSection = ({ course }: { course?: VaasCourse | null }) => {
  const vaasLocations = (course?.vaas_locations || []).flatMap(
    (location) => location?.urls || [],
  )

  return (
    <Card>
      <CardHeader>
        <CardTitle>VAAS locations</CardTitle>
      </CardHeader>
      <CardContent>
        {vaasLocations.length > 0 ? (
          <ul className="list-disc space-y-1 pl-5 text-sm text-muted-foreground">
            {vaasLocations.map((location) => (
              <li key={location}>{location}</li>
            ))}
          </ul>
        ) : (
          <div className="text-sm text-muted-foreground">
            No VAAS locations found.
          </div>
        )}
      </CardContent>
    </Card>
  )
}

export default VaasLocationsSection
